import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readBirthday: emisor =>
    api
      .send({
        query: gql`
          query READ_ALL($emisor: ID!) {
            Cliente {
              readBirthday(emisor: $emisor) {
                _id
                dayOfBirth
                nombre
                fechaNacimiento
                correoElectronicoContacto
                categoria {
                  nombre
                  color
                }
                ciclo
                total
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Cliente.readBirthday),
  readBySearchString: (emisor, searchString, ejecutivo) =>
    api
      .send({
        query: gql`
          query readBySearchString($emisor: ID!, $searchString: String!, $ejecutivo: ID) {
            Cliente {
              readBySearchString(emisor: $emisor, searchString: $searchString, ejecutivo: $ejecutivo) {
                _id
                nombre
                identificacion {
                  numero
                }
                correoElectronicoContacto
                correoElectronico
                telefono {
                  numTelefono
                }
                ciclo
                categoria {
                  nombre
                  color
                }
                ejecutivo {
                  _id
                  nombre
                }
              }
            }
          }
        `,
        variables: { emisor, searchString, ejecutivo }
      })
      .then(result => result.data.data.Cliente.readBySearchString),

  readAllByEmisor: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query READ_ALL($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Cliente {
              readAllByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  nombre
                  identificacion {
                    numero
                  }
                  correoElectronicoContacto
                  correoElectronico
                  telefono {
                    numTelefono
                  }
                  ciclo
                  categoria {
                    nombre
                    color
                  }
                  ejecutivo {
                    _id
                    nombre
                  }

                  updatedAt
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Cliente.readAllByEmisor),

  readAllByIds: _ids =>
    api
      .send({
        query: gql`
          query READ_ALL($_ids: [ID]!) {
            Cliente {
              readAllByIds(_ids: $_ids) {
                _id
                nombre
                identificacion {
                  numero
                }
                genero
                ref
                ciclo
                categoria {
                  nombre
                  color
                }
                ubicacion {
                  provincia {
                    annotation
                  }
                  canton {
                    annotation
                  }
                }
              }
            }
          }
        `,
        variables: {
          _ids
        }
      })
      .then(result => result.data.data.Cliente.readAllByIds),

  readById: _id =>
    api
      .send({
        query: gql`
          query readById($_id: ID!) {
            Cliente {
              readById(_id: $_id) {
                _id
                emisor {
                  _id
                }
                nombre
                identificacion {
                  tipo {
                    id
                  }
                  numero
                }
                identificacionExtranjero
                genero
                nombreComercial
                categoria {
                  _id
                  detalle
                }
                ubicacion {
                  provincia {
                    id
                  }
                  canton {
                    id
                  }
                  distrito {
                    id
                  }
                  otrasSenas
                  lat
                  long
                }
                telefono {
                  codigoPais
                  numTelefono
                }
                correoElectronico
                correoElectronicoContacto

                fechaNacimiento
                ref
                assets {
                  src
                }
                accion {
                  _id
                  _idUsuario
                  tipo
                  # usuario
                  prodServ
                  detalle
                  fecha

                  updatedAt
                  createdAt
                }
                ciclo
                cicloHistorico {
                  _id
                  ciclo
                  detalle
                  fecha
                }

                ejecutivo {
                  _id
                  nombre
                }

                cuentaContable
                plazoCredito
                limiteCredito
                limiteCreditoBlock
                codigoActividadReceptor

                waNotifica
                waMensaje
                waTelefonos

                updatedAt
                createdAt
              }
            }
          }
        `,
        variables: { _id }
      })
      .then(result => result.data.data.Cliente.readById),

  readByIdPaymentLink: _id =>
    api
      .send({
        query: gql`
          query readById($_id: ID!) {
            Cliente {
              readById(_id: $_id) {
                _id
                nombre
                identificacion {
                  tipo {
                    id
                  }
                  numero
                }
                identificacionExtranjero
                nombreComercial
                correoElectronico
                correoElectronicoContacto

                customerId
                paymentMethods {
                  last4
                  paymentMethodId
                }
              }
            }
          }
        `,
        variables: { _id }
      })
      .then(result => result.data.data.Cliente.readById),
  readCron: emisor =>
    api
      .send({
        query: gql`
          query readCron($emisor: ID!) {
            Cliente {
              readCron(emisor: $emisor) {
                emisor {
                  _id
                }
                ciclos {
                  nombre
                  valor
                }

                updatedAt
                createdAt
              }
            }
          }
        `,
        variables: { emisor }
      })
      .then(result => result.data.data.Cliente.readCron),

  readByFactura: _id =>
    api
      .send({
        query: gql`
          query readById($_id: ID!) {
            Cliente {
              readById(_id: $_id) {
                _id
                nombre
                correoElectronico
                identificacion {
                  tipo {
                    id
                  }
                  numero
                }
                identificacionExtranjero

                telefono {
                  numTelefono
                  codigoPais
                }

                categoria {
                  _id
                  detalle

                  nombre
                  esPorcentual
                  valor
                  color
                }
                ciclo

                # conta
                cuentaContable
                plazoCredito
                limiteCredito
                limiteCreditoBlock
                codigoActividadReceptor

                # wa
                waNotifica
                waTelefonos
                waMensaje
              }
            }
          }
        `,
        variables: { _id }
      })
      .then(result => result.data.data.Cliente.readById),

  readByEmail: (emisor, email) =>
    api
      .send({
        query: gql`
          query readByEmail($emisor: ID!, $email: String!) {
            Cliente {
              readByEmail(emisor: $emisor, email: $email) {
                _id
                nombre
                correoElectronico
                fechaNacimiento
                genero
                ciclo

                identificacion {
                  tipo {
                    id
                  }
                  numero
                }

                telefono {
                  numTelefono
                  codigoPais
                }

                ubicacion {
                  provincia {
                    id
                  }
                  canton {
                    id
                  }
                  distrito {
                    id
                  }
                  otrasSenas
                }
              }
            }
          }
        `,
        variables: { emisor, email }
      })
      .then(result => result.data.data.Cliente.readByEmail),

  create: input =>
    api
      .send({
        query: gql`
          mutation create($input: ClienteInput!) {
            Cliente {
              create(input: $input) {
                _id
                nombre
                correoElectronico
                correoElectronicoContacto
                telefono {
                  numTelefono
                }
                ciclo
                ejecutivo {
                  _id
                  nombre
                }
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Cliente.create),

  eCommerceCreate: ({ input }) =>
    api
      .send({
        query: gql`
          mutation create($input: ClienteInput!) {
            Cliente {
              eCommerceCreate(input: $input) {
                _id
                customerId
                paymentMethods {
                  paymentMethodId
                  last4
                }
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Cliente.eCommerceCreate),

  setBalance: (_id, monto, type, detalle, _idPago) =>
    api
      .send({
        query: gql`
          mutation setBalance($_id: ID!, $monto: Float!, $type: ACCOUNT_TYPE!, $detalle: String, $_idPago: ID!) {
            Cliente {
              setBalance(_id: $_id, monto: $monto, type: $type, detalle: $detalle, _idPago: $_idPago)
            }
          }
        `,
        variables: {
          _id,
          monto,
          type,
          detalle,
          _idPago
        }
      })
      .then(result => result.data.data.Cliente.setBalance),

  getBalanceTotal: _id =>
    api
      .send({
        query: gql`
          query getBalanceTotal($_id: ID!) {
            Cliente {
              getBalanceTotal(_id: $_id)
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Cliente.getBalanceTotal),

  getBalance: _id =>
    api
      .send({
        query: gql`
          query getBalance($_id: ID!) {
            Cliente {
              getBalance(_id: $_id) {
                monto
                type
                detalle
                fecha
                total
                _idPago
                consecutivo
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Cliente.getBalance),

  getBalancesByDate: (emisor, start, end) =>
    api
      .send({
        query: gql`
          query getBalancesByDate($emisor: ID!, $start: Date!, $end: Date!) {
            Cliente {
              getBalancesByDate(emisor: $emisor, start: $start, end: $end) {
                _id
                nombre
                monto
                type
                detalle
                fecha
                total
              }
            }
          }
        `,
        variables: {
          emisor,
          start,
          end
        }
      })
      .then(result => result.data.data.Cliente.getBalancesByDate),

  getBalanceAccount: emisor =>
    api
      .send({
        query: gql`
          query getBalanceAccount($emisor: ID!) {
            Cliente {
              getBalanceAccount(emisor: $emisor)
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Cliente.getBalanceAccount),

  getBalanceAccountByDate: (emisor, start, end) =>
    api
      .send({
        query: gql`
          query getBalanceAccountByDate($emisor: ID!, $start: Date!, $end: Date!) {
            Cliente {
              getBalanceAccountByDate(emisor: $emisor, start: $start, end: $end)
            }
          }
        `,
        variables: {
          emisor,
          start,
          end
        }
      })
      .then(result => result.data.data.Cliente.getBalanceAccountByDate),

  createCron: input =>
    api
      .send({
        query: gql`
          mutation createCron($input: CronInput!) {
            Cliente {
              createCron(input: $input)
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Cliente.createCron),

  delete: input =>
    api
      .send({
        query: gql`
          mutation delete($input: [ID!]!) {
            Cliente {
              delete(input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { input }
      })
      .then(result => result.data.data.Cliente.delete),

  setCiclo: (_id, ciclo, detalle) =>
    api
      .send({
        query: gql`
          mutation setCiclo($_id: ID!, $ciclo: String!, $detalle: String) {
            Cliente {
              setCiclo(_id: $_id, ciclo: $ciclo, detalle: $detalle)
            }
          }
        `,
        variables: {
          _id,
          ciclo,
          detalle
        }
      })
      .then(result => result.data.data.Cliente.setCiclo),

  statsCiclo: _id =>
    api
      .send({
        query: gql`
          query statsCiclo($_id: ID!) {
            Cliente {
              statsCiclo(_id: $_id) {
                ciclo
                count
              }
            }
          }
        `,
        variables: { _id }
      })
      .then(result => result.data.data.Cliente.statsCiclo),

  statsAnnCiclo: _id =>
    api
      .send({
        query: gql`
          query statsAnnCiclo($_id: ID!) {
            Cliente {
              statsAnnCiclo(_id: $_id) {
                ciclo
                months {
                  # year
                  month
                  count
                }
              }
            }
          }
        `,
        variables: { _id }
      })
      .then(result => result.data.data.Cliente.statsAnnCiclo),

  healthCheck: () =>
    api
      .send({
        query: gql`
          query healthCheck {
            healthCheck
          }
        `
      })
      .then(result => Promise.resolve(result.data.data.healthCheck)),

  setEjecutivo: (_id, ejecutivo) =>
    api
      .send({
        query: gql`
          mutation setEjecutivo($_id: ID!, $ejecutivo: EjecutivoInput!) {
            Cliente {
              setEjecutivo(_id: $_id, ejecutivo: $ejecutivo)
            }
          }
        `,
        variables: {
          _id,
          ejecutivo
        }
      })
      .then(result => result.data.data.Cliente.setEjecutivo),

  readTotalRegistros: (emisor, ejecutivo) =>
    api
      .send({
        query: gql`
          query readTotalRegistros($emisor: ID!, $ejecutivo: ID) {
            Cliente {
              readTotalRegistros(emisor: $emisor, ejecutivo: $ejecutivo)
            }
          }
        `,
        variables: {
          emisor,
          ejecutivo
        }
      })
      .then(result => result.data.data.Cliente.readTotalRegistros),

  readAutoPayTransactions: emisor =>
    api
      .send({
        query: gql`
          query readAll($emisor: ID!) {
            AutoPay {
              readAll(emisor: $emisor) {
                _id
                detalle
                try
                status
                cliente
                consecutivo
                monto
                updatedAt
              }
            }
          }
        `,
        variables: { emisor }
      })
      .then(result => result.data.data.AutoPay.readAll),

  saveCodigoActividadReceptor: (_id, codigoActividadReceptor) =>
    api
      .send({
        query: gql`
          mutation saveCodigoActividadReceptor($_id: ID!, $codigoActividadReceptor: String!) {
            Cliente {
              saveCodigoActividadReceptor(_id: $_id, codigoActividadReceptor: $codigoActividadReceptor)
            }
          }
        `,
        variables: {
          _id,
          codigoActividadReceptor
        }
      })
      .then(result => result.data.data.Cliente.saveCodigoActividadReceptor),

  setCuentaContable: (_id, cuentaContable) =>
    api
      .send({
        query: gql`
          mutation setCuentaContable($_id: ID!, $cuentaContable: ID!) {
            Cliente {
              setCuentaContable(_id: $_id, cuentaContable: $cuentaContable)
            }
          }
        `,
        variables: {
          _id,
          cuentaContable
        }
      })
      .then(result => result.data.data.Cliente.setCuentaContable)
}
